import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig, MatSnackBarRef, TextOnlySnackBar } from '@angular/material/snack-bar';

@Injectable({ providedIn: 'root' })
export class Toastbar extends MatSnackBar {
    override open(message: string, action?: string, config?: MatSnackBarConfig): MatSnackBarRef<TextOnlySnackBar> {
        const ref = super.open(message, action, config);

        ref.afterOpened().subscribe(() => {
            const element = ref.containerInstance._elementRef.nativeElement;

            element.addEventListener('click', () => {
                ref.dismiss();
            });
        });

        return ref;
    }
}